import React from 'react';
import classNames from 'classnames';
import { ABSButton } from '../ABSButton';
import ABSIcon from '../ABSIcon';
import ABSModal from '../ABSModal';
import { IABSConfirmProps } from './interface';
import './index.less';

export class ABSConfirm extends React.Component<IABSConfirmProps> {
  static defaultProps = {
    type: 'success',
    btnText: '确认'
  };

  modal: ABSModal | null;

  onConfirm = () => {
    const { onConfirm } = this.props;
    if ( onConfirm && typeof onConfirm === 'function') {
      onConfirm();
    }
  };

  show = (show: boolean, callback?: () => void) => {
    if (this.modal) {
      this.modal.show(show, callback);
    }
  };
  
  renderFooter() {
    const { btnText } = this.props;
    return (
        [
          (
            <ABSButton 
              key="submit" 
              type="primary"
              onClick={this.onConfirm}
              icon="check"
            > {btnText} 
            </ABSButton>
          )
        ]
    );
  }

  getContent = () => {
    const { title, content, type } = this.props;
    // 通过弹框类型选择icon类型
    let iconType = 'check-circle';
    switch (type) {
      case 'success':
        iconType = 'check-circle';
        break;
      case 'error':
        iconType = 'close-circle';
        break;
      case 'warning':
        iconType = 'exclamation-circle';
        break;
      case 'delete':
        return  (
        <div className="abs-confirm-content-delete">
          <ABSIcon type="warning-filled" size={18} />
          <p>{title}</p>
          <div style={{ clear: 'both' }} />
        </div>
      );
      // case 'info':
      //   iconType = 'info-circle';
      //   break;
      default:
        break;
    }
    return ( 
      <><h2 className="abs-confirm-title">
          <div className="abs-confirm-title-icon">
            <ABSIcon isAnt={true} size={24} type={iconType} theme="filled" 
              className={`abs-ant-icon-${type}`} />
          </div>
          <div className="abs-confirm-title-text">{title}</div>
        </h2>
        <div className="abs-confirm-content">
          {content}
        </div>
      </> 
    );
  }

  getPropsByType = () => {
    const { type, width, className } = this.props;
    let defaultClassName = 'abs-confirm';
    let classNameDelete = 'abs-confirm-modal-delete';
    let props;
    if ( type === 'delete') {
      props = {
        ...props,
        width: 360,
      className: classNames(defaultClassName, classNameDelete, className),
      onConfirm: this.onConfirm,
      };
    } else {
      props = {
        ...props,
        width,
        className: classNames(defaultClassName, className),
        footer: this.renderFooter()
      };
    }
    return props;
  }

  public render() {
    const typeProps = this.getPropsByType();
    const gotContent = this.getContent();
    return (
        <ABSModal
          content={gotContent}
          ref={view => (this.modal = view)}
          destroyOnClose={true}
          {...typeProps}
        />
          
    );
  }
}

export { IABSConfirmProps };
export default ABSConfirm;


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/ABSConfirm/index.tsx